import React from "react";

const SecureDataSection = () => {
  return (
    <div className="w-full bg-black py-12 text-center">
      {/* Başlık ve Buton Aynı Satırda ve Boşluklu */}
      <div className="flex items-center justify-center gap-8 flex-wrap">
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 tracking-wide">
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-purple-600">
            VERİLERİNİZ GÜVENDE
          </span>

        </h2>
        <button className="px-4 py-2 text-lg font-semibold text-white rounded-md bg-gradient-to-r from-red-500 to-purple-600 shadow-lg hover:shadow-pink-500/50 hover:scale-105 transition-all duration-300">
          İncele
        </button>
      </div>
    </div>
  );
};

export default SecureDataSection;
